import {Injectable} from '@angular/core';
import {DataApiService} from "../../api/data-api.service";
import { RuoloUtenteEnum } from 'src/model/enum/TipologiaUtenteEnum';

export interface User {
  nome: string,
  cognome: string,
  businessUnitId: number,
  businessUnit: string,
  ruoli: string[],
  branch: string,
  tipologiaUtente: string,
  uid: string
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: User | undefined = undefined;

  constructor(private dataApiService: DataApiService) {
  }

  async getUser(): Promise<User | undefined> {
    if (this.user === undefined) {
      this.user = await this.dataApiService.getUserInfo();
    }
    return this.user;
  }

  determineSicAniaUser(): boolean {
    return !!this.user?.ruoli.some((userRole: string) => {
      return [RuoloUtenteEnum.ANIA_ADMIN.toString(), RuoloUtenteEnum.ANIA_BASE.toString()].includes(userRole);
    });
  }
}
